import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import StepConnector from '@mui/material/StepConnector';
import styled from 'styled-components';
import MaterialPaper from '@mui/material/Paper';
import Paper from '@mui/material/Paper';


export const useStyles = makeStyles((theme) => ({
    title: {
        color: theme.palette.primary.main,
        fontSize: '16px',
        fontWeight: 'bold',
    },
    uppyContainer: {
        '& .uppy-Dashboard-AddFiles-title button, & .uppy-StatusBar-actionBtn--upload, & .uppy-DashboardTab-btn, & .uppy-Webcam-button': {
            minWidth: '150px !important',
        },
    },
    checkIcon: {
        color: '#4caf50',
        fontWeight: 'bold',
        backgroundColor: 'transparent',
        borderRadius: '50%',
        width: '300px',
        height: '300px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    imageVerificationContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
    imageContainer: {
        position: 'relative',
        width: '621.13px',
        height: '465.84px',
        border: '2px solid #ddd',
        borderRadius: '8px',
        overflow: 'hidden',
    },
    verifyingOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        '& p': {
            marginTop: theme.spacing(1),
            fontSize: '16px',
        },
    },
    step3Container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(3),
    },
    successOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    imageComparisonContainer: {
        display: 'flex',
        gap: theme.spacing(4),
        alignItems: 'flex-start',
    },
    imageWithTitle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& h4': {
            margin: `0 0 ${theme.spacing(1)}px 0`,
            fontSize: '14px',
            fontWeight: 'bold',
        },
    },
    rightAlignedButtons: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(1),
        width: '100%',
        minHeight: '60px',
        alignItems: 'center',
    },
    errorOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    errorIcon: {
        color: '#f44336',
        fontWeight: 'bold',
        backgroundColor: 'transparent',
        borderRadius: '50%',
        width: '300px',
        height: '300px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));

export const useColorlibStepIconStyles = makeStyles({
    root: {
        backgroundColor: '#ccc',
        zIndex: 1,
        color: '#fff',
        width: 50,
        height: 50,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    active: {
        backgroundImage:
            'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
    completed: {
        backgroundImage:
            'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    },
});

export const ColorlibConnector = withStyles({
    alternativeLabel: {
        top: 22,
    },
    active: {
        '& $line': {
            backgroundImage:
                'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
        },
    },
    completed: {
        '& $line': {
            backgroundImage:
                'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
        },
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: '#eaeaf0',
        borderRadius: 1,
    },
})(StepConnector);

export function ColorlibStepIcon(props) {
    const classes = useColorlibStepIconStyles();
    const { active, completed } = props;

    const icons = {
        1: <PhotoCameraIcon />,
        2: <CloudSyncIcon />,
        3: <VerifiedUserIcon />,
    };

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
            })}
        >
            {icons[String(props.icon)]}
        </div>
    );
}

ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
};


export const ContainerPaper = styled(MaterialPaper)`
    display: grid;
    background-color: white;
    padding: 20px 30px 20px 30px;
    margin: 5px;
    grid-gap: 5px;
`;
export const BannerMessageContainer = styled.div`
    display: grid;
    grid-template-columns: auto auto auto;
    justify-items: flex-start;
    margin-left: 10px;
`;
export const PatientInfoContainer = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    grid-gap: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 10px;
    justify-items: flex-start;
`;
export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 30px;
    margin-bottom: 30px;
`;
export const GreyPaperContainer = styled(Paper)`
    background-color: #f8f3f3;
    margin: 10px 30px;
`;
export const VerifyManualContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 20px 10px;
    margin-top: 10px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #333;

    ol {
        margin: 0;
        padding-left: 20px;
    }

    ol li + li {
    margin-top: 20px;
    }

    label {
        display: flex;
        align-items: center;
        gap: 10px;
    }
`;
